import { Component, ElementRef, ViewChild } from "@angular/core";

@Component({
  selector: "app-ipqc-pdf-report",
  templateUrl: "./ipqc-pdf-report.component.html",
  styleUrls: ["./ipqc-pdf-report.component.css"],
})
export class IpqcPdfReportComponent {
  constructor() {}

  @ViewChild("compReportTemp") compReportTemp: ElementRef<HTMLDivElement>;
  @ViewChild("packDataTemp") packDataTemp: ElementRef<HTMLDivElement>;
  @ViewChild("reportsummaryTemp") reportsummaryTemp: ElementRef<HTMLDivElement>;
  @ViewChild("pdfReportContainer")
  pdfReportContainer: ElementRef<HTMLDivElement>;
  ecalLogo = "assets/img/epack-pdf-report/enginecal_logo.png";
  expoLogo = "assets/img/epack-pdf-report/exponent_logo.png";
  expoLogoBlack = "assets/img/epack-pdf-report/exponent_logo_black.png";

  packDataMapping = {
    test_id: "Test ID",
    date: "Test Date",
    pack_id: "Battery Unique Key",
    bms_id: "BMS Unique Key",
    product_id: "Product",
    variant_id: "Variant",
    sop_flash: "SOP Flash",
    test_type: "Test Type",
    battery_type: "Battery Type",
  };

  triggerPdfGeneration({
    packData,
    metaData,
  }: {
    packData: { [key: string]: string | number };
    metaData: { [key: string]: string | number };
  }) {
    let lowerCasedMetaData = {};

    Object.entries(metaData).forEach(([key, value]) => {
      let lowercasedKey = key.toLowerCase();
      lowerCasedMetaData[lowercasedKey] = value.toString().toLowerCase();
    });

    this.generatePdf({ packData, metaData: lowerCasedMetaData });
  }

  private generatePdf({
    packData,
    metaData,
  }: {
    packData: { [key: string]: string | number };
    metaData: { [key: string]: string | number };
  }) {
    this.clearPdfUI();
    this.renderPacketData(packData);

    if (packData.battery_type === "piccolo") {
      this.renderPicoloSummaryReport(metaData);
      this.generatePicoloComprehenviseReport(metaData);
    } else {
      this.renderTgSummaryReport(metaData);
      this.generateTGComprehenviseReport(metaData);
    }

    this.pdfReportContainer.nativeElement.style.display = "block";
    const reportElement = this.pdfReportContainer.nativeElement;
    const pdfWidth = reportElement.clientWidth;
    const pdfHeight = reportElement.clientHeight / 2;

    const docWindow: any = window;
    const { jsPDF } = docWindow.jspdf;

    const doc = new jsPDF({
      unit: "px",
      format: [pdfWidth, pdfHeight + 9],
    });

    doc.html(reportElement, {
      callback: () => {
        const pdfBlob = doc.output("blob");
        const pdfUrl = URL.createObjectURL(pdfBlob);
        this.pdfReportContainer.nativeElement.style.display = "none";
        window.open(pdfUrl, "_blank");
      },
    });
  }

  private generateTGComprehenviseReport(metaData: {
    [key: string]: string | number;
  }) {
    const reportData: {
      [key: string]: {
        [key: string]: {
          unit: string;
          result_signal: string;
          analytic_signal: string | null;
        };
      };
    } = {
      "BMS CAN UP check": {
        "BMS CAN UP check": {
          unit: "-",
          result_signal: "can_bms_status",
          analytic_signal: "bms_can_up_fb",
        },
      },

      "Idle State check": {
        "Battery State during Idle": {
          unit: "State",
          result_signal: "battery_state_bms_status",
          analytic_signal: "idle_battery_state_bms",
        },
        "Battery State prior to Current sense harness check": {
          unit: "State",
          result_signal: "curr_sense_har_btry_status",
          analytic_signal: "current_sense_battery_state_bms",
        },
        "Battery State during Discharge": {
          unit: "State",
          result_signal: "discharge_bms_state_status",
          analytic_signal: "discharge_battery_state_bms",
        },
        "Battery State during Charge": {
          unit: "State",
          result_signal: "charge_bms_state_status",
          analytic_signal: "charge_battery_state_bms",
        },
      },

      "Voltage Range and Imbalance check": {
        "Voltage Range": {
          unit: "-",
          analytic_signal: null,
          result_signal: "voltage_range_status",
        },
        "Voltage Imbalance": {
          unit: "mv",
          analytic_signal: "voltage_imbalance",
          result_signal: "voltage_imbalance_status",
        },
      },

      "Temperature Range and Imbalance check": {
        "Temperature Range": {
          unit: "-",
          analytic_signal: null,
          result_signal: "temp_range_status",
        },
        "Temperature Imbalance": {
          unit: "Deg C",
          analytic_signal: "temperature_imbalance",
          result_signal: "temp_imbalance_status",
        },
      },

      "Continuity and Feedback Checks": {
        "CP Continuity": {
          analytic_signal: "cp_continuity_fb",
          result_signal: "cp_continuity_status",
          unit: "Feedback",
        },
        "PP Feedback from BMS": {
          analytic_signal: "proximity_pilot_in_bms_fb",
          result_signal: "pp_feedback_status",
          unit: "Feedback",
        },
        "Motor Enable continuity": {
          analytic_signal: "motor_enable_continuity_fb",
          result_signal: "motor_enable_feedback_status",
          unit: "Feedback",
        },
        "Solenoid retract feedback": {
          analytic_signal: "solenoid_retract_bms_fb",
          result_signal: "solenoid_retract_feedback_status",
          unit: "Feedback",
        },
        "Solenoid actuate feedback": {
          analytic_signal: "solenoid_actuate_bms_fb",
          result_signal: "solenoid_feedback_status",
          unit: "Feedback",
        },
        "Current sensor harness ADC": {
          analytic_signal: "adc_current_mcu",
          result_signal: "curr_sense_har_feedback_status",
          unit: "Feedback",
        },
      },

      "Contactor & Path health": {
        "Discharge Precharge": {
          analytic_signal: null,
          result_signal: "discharge_precharge_status",
          unit: "-",
        },

        "Discharge Contactor Voltage": {
          analytic_signal: "discharge_contactor_on_voltage",
          result_signal: "discharge_contactor_voltchk_status",
          unit: "V",
        },

        "Discharge Contactor Weld check": {
          analytic_signal: "discharge_contactor_weld_check_voltage",
          result_signal: "discharge_contactor_weld_status",
          unit: "V",
        },

        "Discharge Path health": {
          analytic_signal: "discharge_path_health_check",
          result_signal: "discharge_path_health_status",
          unit: "V",
        },

        "Charge Precharge": {
          analytic_signal: null,
          result_signal: "charge_precharge_status",
          unit: "-",
        },

        "Charge Contactor Voltage": {
          analytic_signal: "charge_contactor_on_voltage",
          result_signal: "charge_contactor_volt_status",
          unit: "V",
        },

        "Charge Contactor Weld check": {
          analytic_signal: "charge_contactor_weld_check_voltage",
          result_signal: "charge_contactor_weld_status",
          unit: "V",
        },

        "Charge Path Health": {
          analytic_signal: "charge_path_health_check",
          result_signal: "charge_path_health_status",
          unit: "V",
        },
      },

      "EEPROM Memory write /read check & Unique ID Flashing": {
        "EEPROM Memory Flashing": {
          analytic_signal: "eeprom_batteryid_verification",
          result_signal: "eeprom_memory_status",
          unit: "-",
        },
        "Battery Unique Key Flashing": {
          analytic_signal: "battery_id_flash_readback",
          result_signal: "btrykey_flash_verify_status",
          unit: "-",
        },
        "BMS Unique Key Flashing": {
          analytic_signal: "bms_id_flash_readback",
          result_signal: "bmskey_flash_verify_status",
          unit: "-",
        },
      },
    };

    const table = document.createElement("table");
    const headerTr = document.createElement("tr");
    const groupTh = document.createElement("th");
    const testTh = document.createElement("th");
    const analyticTh = document.createElement("th");
    const unitTh = document.createElement("th");
    const resultTh = document.createElement("th");

    groupTh.textContent = "Group";
    testTh.textContent = "Test";
    analyticTh.textContent = "Analytic";
    resultTh.textContent = "Result";
    unitTh.textContent = "Unit";

    headerTr.appendChild(groupTh);
    headerTr.appendChild(testTh);
    headerTr.appendChild(analyticTh);
    headerTr.appendChild(unitTh);
    headerTr.appendChild(resultTh);

    table.appendChild(headerTr);
    table.style.width = "100%";
    table.style.textAlign = "center";
    table.border = "1";

    this.compReportTemp.nativeElement.appendChild(table);

    Object.entries(reportData).forEach(([group, tests]) => {
      const totalTests = Object.keys(tests).length;
      Object.entries(tests).forEach(([test, testData], index) => {
        const { unit, result_signal, analytic_signal } = testData;
        const result = metaData[result_signal];
        const analytic = metaData[analytic_signal] ?? "-";

        const tr = document.createElement("tr");
        const testTd = document.createElement("td");
        const analyticTd = document.createElement("td");
        const resultTd = document.createElement("td");
        const unitTd = document.createElement("td");

        testTd.textContent = test;
        resultTd.textContent = String(result);
        analyticTd.textContent = String(analytic ?? "-");
        unitTd.textContent = unit;

        resultTd.style.textTransform = "capitalize";
        analyticTd.style.textTransform = "capitalize";

        if (String(analytic).toLowerCase().trim() === "fail") {
          analyticTd.style.color = "#b90000";
          analyticTd.style.backgroundColor = "#F5C1C3";
        }

        if (String(result).toLowerCase().trim() === "fail") {
          resultTd.style.color = "#b90000";
          resultTd.style.backgroundColor = "#F5C1C3";
        }

        if (index === 0) {
          const groupTd = document.createElement("td");
          const remarkTd = document.createElement("td");
          groupTd.textContent = group;
          groupTd.rowSpan = totalTests;
          remarkTd.style.textTransform = "capitalize";

          groupTd.style.maxWidth = "120px";

          tr.appendChild(groupTd);
        }

        tr.appendChild(testTd);
        tr.appendChild(analyticTd);
        tr.appendChild(unitTd);
        tr.appendChild(resultTd);

        table.appendChild(tr);
      });
    });
  }

  private generatePicoloComprehenviseReport(metaData: {
    [key: string]: string | number;
  }) {
    const reportData: {
      [key: string]: {
        [key: string]: {
          unit: string;
          result_signal: string;
          analytic_signal: string | null;
        };
      };
    } = {
      "BMS CAN UP check": {
        "BMS CAN UP check": {
          analytic_signal: "m_bms_can_up_fb",
          result_signal: "m_bms_can_bms_status",
          unit: "-",
        },
      },
      "Idle State check": {
        "Battery State during Idle": {
          analytic_signal: "m_bms_idle_battery_state",
          result_signal: "m_bms_battery_state_bms_status",
          unit: "State",
        },
        "Battery State prior to Current sense harness check": {
          analytic_signal: "m_bms_current_sense_battery_state",
          result_signal: "m_bms_curr_sense_har_btry_status",
          unit: "State",
        },
        "Battery State during Discharge": {
          analytic_signal: "m_bms_discharge_battery_state",
          result_signal: "m_bms_discharge_bms_state_status",
          unit: "State",
        },
        "Battery State during Charge": {
          analytic_signal: "m_bms_charge_battery_state",
          result_signal: "m_bms_charge_bms_state_status",
          unit: "State",
        },
      },
      "Voltage Range and Imbalance check": {
        "Voltage Range": {
          analytic_signal: "-",
          result_signal: "m_bms_voltage_range_status",
          unit: "-",
        },
        "Voltage Imbalance": {
          analytic_signal: "m_bms_voltage_imbalance",
          result_signal: "m_bms_voltage_imbalance_status",
          unit: "mv",
        },
      },
      "Temperature Range and Imbalance check": {
        "Temperature Range ": {
          analytic_signal: "-",
          result_signal: "m_bms_temp_range_status",
          unit: "-",
        },
        "Temperature Imbalance": {
          analytic_signal: "m_bms_temperature_imbalance",
          result_signal: "m_bms_temp_imbalance_status",
          unit: "Deg C",
        },
      },
      "Continuity and Feedback Checks": {
        "CP Continuity": {
          analytic_signal: "m_bms_cp_continuity_fb",
          result_signal: "m_bms_cp_continuity_status",
          unit: "Feedback",
        },
        "PP Feedback from BMS": {
          analytic_signal: "m_bms_proximity_pilot_in_fb",
          result_signal: "m_bms_pp_feedback_status",
          unit: "Feedback",
        },
        "Motor Enable continuity": {
          analytic_signal: "m_bms_motor_enable_continuity_fb",
          result_signal: "m_bms_motor_enable_feedback_status",
          unit: "Feedback",
        },
        "Solenoid retract feedback": {
          analytic_signal: "m_bms_solenoid_retract_fb",
          result_signal: "m_bms_solenoid_retract_feedback_status",
          unit: "Feedback",
        },
        "Solenoid actuate feedback": {
          analytic_signal: "m_bms_solenoid_actuate_fb",
          result_signal: "m_bms_solenoid_feedback_status",
          unit: "Feedback",
        },
        "Current sensor harness ADC": {
          analytic_signal: "m_bms_adc_current_mcu",
          result_signal: "m_bms_curr_sense_har_feedback_status",
          unit: "ADC",
        },
      },
      "Contactor & Path health": {
        "Discharge Precharge": {
          analytic_signal: "-",
          result_signal: "m_bms_discharge_precharge_status",
          unit: "-",
        },
        "Discharge Contactor Voltage": {
          analytic_signal: "m_bms_discharge_contactor_on_voltage",
          result_signal: "m_bms_discharge_contactor_voltchk_status",
          unit: "V",
        },
        "Discharge Contactor Weld check": {
          analytic_signal: "m_bms_discharge_contactor_weld_check_voltage",
          result_signal: "m_bms_discharge_contactor_weld_status",
          unit: "V",
        },
        "Discharge Path health": {
          analytic_signal: "m_bms_discharge_path_health_check",
          result_signal: "m_bms_discharge_path_health_status",
          unit: "V",
        },
        "Charge Precharge": {
          analytic_signal: "-",
          result_signal: "m_bms_charge_precharge_status",
          unit: "-",
        },
        "Charge Contactor Voltage": {
          analytic_signal: "m_bms_charge_contactor_on_voltage",
          result_signal: "m_bms_charge_contactor_volt_status",
          unit: "V",
        },
        "Charge Contactor Weld check": {
          analytic_signal: "m_bms_charge_contactor_weld_check_voltage",
          result_signal: "m_bms_charge_contactor_weld_status",
          unit: "V",
        },
        "Charge Path Health ": {
          analytic_signal: "m_bms_charge_path_health_check",
          result_signal: "m_bms_charge_path_health_status",
          unit: "V",
        },
      },
      "EEPROM Memory write /read check & Unique ID Flashing": {
        "EEPROM Memory Flashing": {
          analytic_signal: "m_bms_eeprom_batteryid_verification",
          result_signal: "m_bms_eeprom_memory_status",
          unit: "-",
        },
        "Battery Unique Key Flashing": {
          analytic_signal: "m_bms_battery_id_flash_readback",
          result_signal: "m_bms_btrykey_flash_verify_status",
          unit: "-",
        },
        "BMS Unique Key Flashing": {
          analytic_signal: "m_bms_id_flash_readback",
          result_signal: "m_bms_bmskey_flash_verify_status",
          unit: "-",
        },
      },
    };

    const table = document.createElement("table");
    const headerTr = document.createElement("tr");
    const groupTh = document.createElement("th");
    const testTh = document.createElement("th");
    const analyticTh = document.createElement("th");
    const unitTh = document.createElement("th");
    const resultTh = document.createElement("th");

    groupTh.textContent = "Group";
    testTh.textContent = "Test";
    analyticTh.textContent = "Analytic";
    resultTh.textContent = "Result";
    unitTh.textContent = "Unit";

    headerTr.appendChild(groupTh);
    headerTr.appendChild(testTh);
    headerTr.appendChild(analyticTh);
    headerTr.appendChild(unitTh);
    headerTr.appendChild(resultTh);

    table.appendChild(headerTr);
    table.style.width = "100%";
    table.style.textAlign = "center";
    table.border = "1";

    this.compReportTemp.nativeElement.appendChild(table);

    Object.entries(reportData).forEach(([group, tests]) => {
      const totalTests = Object.keys(tests).length;
      Object.entries(tests).forEach(([test, testData], index) => {
        const { unit, result_signal, analytic_signal } = testData;
        const result = metaData[result_signal];
        const analytic = metaData[analytic_signal] ?? "-";

        const tr = document.createElement("tr");
        const testTd = document.createElement("td");
        const analyticTd = document.createElement("td");
        const resultTd = document.createElement("td");
        const unitTd = document.createElement("td");

        testTd.textContent = test;
        resultTd.textContent = String(result);
        analyticTd.textContent = String(analytic ?? "-");
        unitTd.textContent = unit;

        resultTd.style.textTransform = "capitalize";
        analyticTd.style.textTransform = "capitalize";

        if (String(analytic).toLowerCase().trim() === "fail") {
          analyticTd.style.color = "#b90000";
          analyticTd.style.backgroundColor = "#F5C1C3";
        }

        if (String(result).toLowerCase().trim() === "fail") {
          resultTd.style.color = "#b90000";
          resultTd.style.backgroundColor = "#F5C1C3";
        }

        if (index === 0) {
          const groupTd = document.createElement("td");
          const remarkTd = document.createElement("td");
          groupTd.textContent = group;
          groupTd.rowSpan = totalTests;
          remarkTd.style.textTransform = "capitalize";

          groupTd.style.maxWidth = "120px";

          tr.appendChild(groupTd);
        }

        tr.appendChild(testTd);
        tr.appendChild(analyticTd);
        tr.appendChild(unitTd);
        tr.appendChild(resultTd);

        table.appendChild(tr);
      });
    });
  }

  private renderTgSummaryReport(metaData: { [key: string]: string | number }) {
    const reportData: {
      [key: string]: string | number;
    } = {
      "Final EOL Result": metaData.final_test_result,
      "BMS CAN UP check": metaData.can_bms_status,
      "Idle State check":
        metaData.battery_state_bms_status &&
        metaData.curr_sense_har_btry_status &&
        metaData.discharge_bms_state_status &&
        metaData.charge_bms_state_status,
      "Voltage Range and Imbalance check":
        metaData.voltage_range_status && metaData.voltage_imbalance_status,
      "Temperature Range and Imbalance check":
        metaData.temp_range_status && metaData.temp_imbalance_status,
      "Continuity and Feedback Checks":
        metaData.cp_continuity_status &&
        metaData.pp_feedback_status &&
        metaData.motor_enable_feedback_status &&
        metaData.solenoid_retract_feedback_status &&
        metaData.solenoid_feedback_status &&
        metaData.curr_sense_har_feedback_status,
      "Contactor & Path health":
        metaData.discharge_precharge_status &&
        metaData.discharge_contactor_voltchk_status &&
        metaData.discharge_contactor_weld_status &&
        metaData.discharge_path_health_status &&
        metaData.charge_path_health_status &&
        metaData.charge_precharge_status &&
        metaData.charge_contactor_volt_status &&
        metaData.charge_contactor_weld_status,
      "EEPROM Memory write /read check & Unique ID Flashing":
        metaData.eeprom_memory_status &&
        metaData.btrykey_flash_verify_status &&
        metaData.bmskey_flash_verify_status,
    };

    let finalResult = "Pass";

    const table = document.createElement("table");
    const headerTr = document.createElement("tr");
    const groupTh = document.createElement("th");
    const testTh = document.createElement("th");
    const resultTh = document.createElement("th");
    const remarkTh = document.createElement("th");

    groupTh.textContent = "Group";
    testTh.textContent = "Test";
    resultTh.textContent = "Test Result";
    remarkTh.textContent = "Final Result";

    headerTr.appendChild(groupTh);
    headerTr.appendChild(testTh);
    headerTr.appendChild(resultTh);
    headerTr.appendChild(remarkTh);

    table.appendChild(headerTr);
    table.style.width = "100%";
    table.style.textAlign = "center";
    table.border = "1";

    this.reportsummaryTemp.nativeElement.appendChild(table);

    Object.entries(reportData).forEach(([key, value]) => {
      if (String(value).trim().toLowerCase() === "fail") {
        finalResult = "Fail";
      }
    });

    const totalRows = Object.entries(reportData).length;

    Object.entries(reportData).forEach(([key, value], index) => {
      const tr = document.createElement("tr");
      const testTd = document.createElement("td");
      const resultTd = document.createElement("td");

      testTd.textContent = key;
      resultTd.textContent = String(value);
      resultTd.style.textTransform = "capitalize";

      if (String(value).toLowerCase().trim() === "fail") {
        resultTd.style.color = "#b90000";
        resultTd.style.backgroundColor = "#F5C1C3";
      }

      if (index === 0) {
        const groupTd = document.createElement("td");
        const remarkTd = document.createElement("td");
        groupTd.textContent = "Report Summary";
        remarkTd.textContent = finalResult;

        if (finalResult.toLowerCase().trim() === "fail") {
          remarkTd.style.color = "#b90000";
          remarkTd.style.backgroundColor = "#F5C1C3";
        }

        groupTd.rowSpan = totalRows;
        remarkTd.rowSpan = totalRows;
        remarkTd.style.textTransform = "capitalize";

        tr.appendChild(groupTd);
        tr.appendChild(testTd);
        tr.appendChild(resultTd);
        tr.appendChild(remarkTd);
      } else {
        tr.appendChild(testTd);
        tr.appendChild(resultTd);
      }

      table.appendChild(tr);
    });
  }
  private renderPicoloSummaryReport(metaData: {
    [key: string]: string | number;
  }) {
    const reportData: {
      [key: string]: string | number;
    } = {
      "Final EOL Result ": metaData.final_test_result,
      "BMS CAN UP check": metaData.m_bms_can_bms_status,
      "Idle State check":
        metaData.m_bms_battery_state_bms_status &&
        metaData.m_bms_curr_sense_har_btry_status &&
        metaData.m_bms_discharge_bms_state_status &&
        metaData.m_bms_charge_bms_state_status,
      "Voltage Range and Imbalance check":
        metaData.m_bms_voltage_range_status &&
        metaData.m_bms_voltage_imbalance_status,
      "Temperature Range and Imbalance check":
        metaData.m_bms_temp_range_status &&
        metaData.m_bms_temp_imbalance_status,
      "Continuity and Feedback Checks":
        metaData.m_bms_cp_continuity_status &&
        metaData.m_bms_pp_feedback_status &&
        metaData.m_bms_motor_enable_feedback_status &&
        metaData.m_bms_solenoid_retract_feedback_status &&
        metaData.m_bms_solenoid_feedback_status &&
        metaData.m_bms_curr_sense_har_feedback_status,
      "Contactor & Path health":
        metaData.m_bms_discharge_precharge_status &&
        metaData.m_bms_discharge_contactor_voltchk_status &&
        metaData.m_bms_discharge_contactor_weld_status &&
        metaData.m_bms_discharge_path_health_status &&
        metaData.m_bms_charge_path_health_status &&
        metaData.m_bms_charge_precharge_status &&
        metaData.m_bms_charge_contactor_volt_status &&
        metaData.m_bms_charge_contactor_weld_status,
      "EEPROM Memory write /read check & Unique ID Flashing":
        metaData.m_bms_eeprom_memory_status &&
        metaData.m_bms_btrykey_flash_verify_status &&
        metaData.m_bms_bmskey_flash_verify_status,
    };

    let finalResult = "Pass";

    const table = document.createElement("table");
    const headerTr = document.createElement("tr");
    const groupTh = document.createElement("th");
    const testTh = document.createElement("th");
    const resultTh = document.createElement("th");
    const remarkTh = document.createElement("th");

    groupTh.textContent = "Group";
    testTh.textContent = "Test";
    resultTh.textContent = "Test Result";
    remarkTh.textContent = "Final Result";

    headerTr.appendChild(groupTh);
    headerTr.appendChild(testTh);
    headerTr.appendChild(resultTh);
    headerTr.appendChild(remarkTh);

    table.appendChild(headerTr);
    table.style.width = "100%";
    table.style.textAlign = "center";
    table.border = "1";

    this.reportsummaryTemp.nativeElement.appendChild(table);

    Object.entries(reportData).forEach(([key, value]) => {
      if (String(value).trim().toLowerCase() === "fail") {
        finalResult = "Fail";
      }
    });

    const totalRows = Object.entries(reportData).length;

    Object.entries(reportData).forEach(([key, value], index) => {
      const tr = document.createElement("tr");
      const testTd = document.createElement("td");
      const resultTd = document.createElement("td");

      testTd.textContent = key;
      resultTd.textContent = String(value);
      resultTd.style.textTransform = "capitalize";

      if (String(value).toLowerCase().trim() === "fail") {
        resultTd.style.color = "#b90000";
        resultTd.style.backgroundColor = "#F5C1C3";
      }

      if (index === 0) {
        const groupTd = document.createElement("td");
        const remarkTd = document.createElement("td");
        groupTd.textContent = "Report Summary";
        remarkTd.textContent = finalResult;

        if (finalResult.toLowerCase().trim() === "fail") {
          remarkTd.style.color = "#b90000";
          remarkTd.style.backgroundColor = "#F5C1C3";
        }

        groupTd.rowSpan = totalRows;
        remarkTd.rowSpan = totalRows;
        remarkTd.style.textTransform = "capitalize";

        tr.appendChild(groupTd);
        tr.appendChild(testTd);
        tr.appendChild(resultTd);
        tr.appendChild(remarkTd);
      } else {
        tr.appendChild(testTd);
        tr.appendChild(resultTd);
      }

      table.appendChild(tr);
    });
  }

  private renderPacketData(packData: { [key: string]: any }) {
    const ignoredData = ["battery_type"];

    Object.entries(packData).forEach((item) => {
      if (!ignoredData.includes(item[0])) {
        const [key, value] = item;
        const dataContainer = document.createElement("p");

        dataContainer.innerHTML = `<b style="margin: 0; font-weight: 500">${this.packDataMapping[key]}: </b>${value}`;

        dataContainer.style.margin = "0";
        dataContainer.style.border = "1px solid black";
        dataContainer.style.padding = "0 0.4rem";

        this.packDataTemp.nativeElement.appendChild(dataContainer);
      }
    });
  }

  private clearPdfUI() {
    this.packDataTemp.nativeElement.innerHTML = "";
    this.reportsummaryTemp.nativeElement.innerHTML = "";
    this.compReportTemp.nativeElement.innerHTML = "";
  }
}
